import isemail from "isemail";
import immutable from "object-path-immutable";
import PropTypes from "prop-types";
import React from "react";
import * as Utilities from "../../utilities.js";
import { Cart } from "./cart";
import { ComplianceForm } from "./compliance_form.jsx";
import { ExternalPaymentForm } from "./external_payment_form.js.jsx";
import { StripePaymentForm } from "./stripe_payment_form.js.jsx";
import { ReservationTimer } from './reservation_timer.jsx';

/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Main Payment "pane" of the checkout process
export class Payment extends React.Component {
      constructor(props) {
        super(props);

        this.UNSAFE_componentWillReceiveProps =
          this.UNSAFE_componentWillReceiveProps.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBillingAddressChange = this.onBillingAddressChange.bind(this);
        this._setError = this._setError.bind(this);
        this._validateForm = this._validateForm.bind(this);

        this.state = {
          loading: false,
          name: props.user_name || "",
          email: props.user_email || "",
          errors: {
            stripe: null,
            name: null,
            email: null,
            provider: null,
            order: null,
          },
          billing_address: props.billing_address,
        };
      }

      UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props === nextProps) {
          return;
        }

        if (nextProps.checkout_errors?.card) {
          this._setError("stripe", nextProps.checkout_errors.card);
        }
        if (nextProps.checkout_errors?.name) {
          this._setError("name", nextProps.checkout_errors.name);
        }
        if (nextProps.checkout_errors?.email) {
          this._setError("email", nextProps.checkout_errors.email);
        }
        if (nextProps.checkout_errors?.provider) {
          this._setError("provider", nextProps.checkout_errors.provider);
        }
        if (nextProps.checkout_errors?.order) {
          this._setError("order", nextProps.checkout_errors.order);
        }

        return this.setState({
          loading: false,
        });
      }

      onBack(event) {
        event.preventDefault();
        this.props.onGoBack?.();
      }

      onCancel(event) {
        event.preventDefault();
        this.props.onCancel?.();
      }

      // Create the stripe token from the entered data, and if valid, call the callback specified
      onSubmit(event) {
        event.preventDefault();

        // Prevent submission if the form is still loading
        if (this.state.loading || this.props.loading) {
          return;
        }

        // Clear error during submission
        this._setError("stripe", null);
        this._setError("order", null);

        this._validateForm();

        // Check for non-Stripe validation errors first
        const hasValidationErrors =
          !!this.state.errors.email ||
          !!this.state.errors.name ||
          Utilities.isBlank(this.state.email) ||
          Utilities.isBlank(this.state.name);

        if (hasValidationErrors) {
          return;
        }

        this.setState({ loading: true });

        if (this.props.cart.total > 0) {
          switch (this.props.payout_account_type) {
            case "ccp":
            case "authorize_net":
            case "touch_net":
              this.setState({ loading: true });
              return this.props.onSubmit?.({
                billing_name: this.state.name,
                billing_email: this.state.email,
                billing_address: this.state.billing_address,
              });

            case "stripe":
              return this.handleStripePayment();

            default:
              return console.error(
                `Unknown payment provider type ${this.props.payout_account_type}`
              );
          }
        } else {
          // cart total == 0
          // This is a zero-cost order, so don't involve stripe and just issue to the server
          this.setState({ loading: true });
          return this.props.onSubmit?.({
            billing_name: this.state.name,
            billing_email: this.state.email,
            billing_address: this.state.billing_address,
          });
        }
      }

      async handleStripePayment() {
        const { stripe, elements, onSubmit } =
          this.props;

        const { error: submitError } = await elements.submit();
        if (submitError) {
          this._setError("stripe", submitError.message);
          this.setState({ loading: false });
          return null;
        }

        // Get confirmation token from stripe
        const { error, confirmationToken } = await stripe.createConfirmationToken({
          elements,
        });

        if (error) {
          this._setError("stripe", error.message);
          this.setState({ loading: false });
          return null;
        }

        try {
          // Successful payment, notify server
          return onSubmit?.({
            confirmation_token: confirmationToken.id,
            billing_name: this.state.name,
            billing_email: this.state.email,
            billing_address: this.state.billing_address,
          });
        } catch (err) {
          // Handle network errors or other unexpected failures
          this._setError(
            "stripe",
            "Unable to process payment. Please try again."
          );
          this.setState({ loading: false });
          console.error("Payment processing error:", err);
          return null;
        }
      }

      // Callback when the other input fields are changed.
      onChange(event) {
        return this.setState(
          immutable.set(this.state, event.target.name, event.target.value),
          this._validateForm
        );
      }

      // Callback when the billing address is changed
      //
      // address_data is { line1, line2, city, country, postal_code, state }
      onBillingAddressChange(address_data) {
        this.setState({ billing_address: address_data });
      }

      // Update the component error state with the key and message provided
      _setError(key, message) {
        return this.setState(
          immutable.set(this.state, ["errors", key], message)
        );
      }

      // Validate the form, email and name. Stripe handles cc validation
      _validateForm() {
        const next_errors = immutable(this.state.errors);

        if (Utilities.isBlank(this.state.name)) {
          next_errors.set("name", "required");
        } else {
          next_errors.set("name", null);
        }

        if (Utilities.isBlank(this.state.email)) {
          next_errors.set("email", "required");
        } else if (!isemail.validate(this.state.email)) {
          next_errors.set("email", "invalid_format");
        } else {
          next_errors.set("email", null);
        }

        return this.setState({ errors: next_errors.value() });
      }

      checkIfEventIsFree() {
        const areTicketsInCartFree = this.props.cart.items.filter(
          (item) => item.price === 0
        );
        if (areTicketsInCartFree.length === this.props.cart.items.length) {
          return true;
        }
        return false;
      }

      shouldCollectTax() {
        return this.props.tax_enabled &&
          this.props.cart.items?.some((item) => item.taxable);
      }

      showTaxMessage() {
        return this.props.tax_enabled &&
          this.props.cart.total > 0 &&
          this.props.cart.items?.some((item) => !item.fees_included);
      }

      // Render some instructional text for external payments
      _renderExternalPaymentForm() {
        return (
          <ExternalPaymentForm
            name={this.state.name}
            email={this.state.email}
            nameError={this.state.errors.name}
            emailError={this.state.errors.email}
            onChange={this.onChange}
            isEventFree={this.checkIfEventIsFree()}
            shouldCollectTax={this.shouldCollectTax()}
          />
        );
      }

      // Render the stripe payment form, and the free payment form
      _renderStripePaymentForm() {
        return (
          <StripePaymentForm
            name={this.state.name}
            email={this.state.email}
            nameError={this.state.errors.name}
            emailError={this.state.errors.email}
            stripeError={this.state.errors.stripe}
            onChange={this.onChange}
            onAddressChange={this.onBillingAddressChange}
            isEventFree={this.checkIfEventIsFree()}
            cartTotal={this.props.cart.total}
            shouldCollectTax={this.shouldCollectTax()}
            initialBillingAddress={this.state.billing_address}
          />
        );
      }

      // Render the appropriate payments form
      _renderPaymentForm() {
        if (
          this.props.cart.total > 0 &&
          this.props.payout_account_type === "stripe"
        ) {
          return this._renderStripePaymentForm();
        }

        return this._renderExternalPaymentForm();
      }

      _getSubmitLabel() {
        if (this.state.loading || this.props.loading) {
          return "Processing...";
        }

        return "Continue";
      }

      render() {
        const submit_label = this._getSubmitLabel();

        return (
          <div className="widget-content">
            <ReservationTimer
              now={this.props.now}
              reservationEnds={this.props.reservation_ends_at}
              browserTimeOffset={this.props.browser_time_offset}
            />

            <form className="car_form form-sidebar" onSubmit={this.onSubmit}>
              <span className="em-section_register_title">Checkout</span>

              <Cart
                items={this.props.cart.items}
                fee={this.props.cart.fee}
                feeLabel="Estimated Fees"
                currency={this.props.currency}
                showTaxMessage={this.showTaxMessage()}
              />

              {this._renderPaymentForm()}

              {/* Generic errors, either from the provider... */}
              {this.state.errors.provider && (
                <div className="payment-provider-error">
                  <p>{this.state.errors.provider}</p>
                </div>
              )}

              {/* about the order in general... */}
              {this.state.errors.order && (
                <div className="payment-provider-error">
                  <p>{this.state.errors.order}</p>
                </div>
              )}

              {/* or an internal server error, or other XHR error */}
              {this.props.error && (
                <div className="payment-provider-error">
                  <p>
                    Unable to complete order. Please try again later. (
                    {this.props.errorMessage})
                  </p>
                </div>
              )}

              <div className="action_button">
                <a
                  href="#"
                  className="cancel_link em-link"
                  onClick={this.onBack}
                >
                  Back
                </a>
                <a
                  href="#"
                  className="cancel_link em-link"
                  onClick={this.onCancel}
                >
                  Cancel
                </a>
                <input
                  type="submit"
                  className="em-button em-primary"
                  value={submit_label}
                />
              </div>
            </form>
          </div>
        );
      }
    }

Payment.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  onSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  onCancel: PropTypes.func,
  stripe: PropTypes.object,
  elements: PropTypes.object,
};
